// Adapated from https://github.com/lpsBetty/angular-croppie/blob/master/angular-croppie.js

export const name = 'croppie';

export default function croppie($window) {
  'ngInject';

  let directive = {
    restrict: 'AE',
    replace: 'false',
    template: require('./croppie.jade'),
    scope: {
      src: '<',
      ngModel: '=',
      options: '='
    },
    link: croppieLink
  };

  return directive;

  function croppieLink(scope, element) {
    // Default
    // NOTE: boundary must be larger than viewport!
    let defaultOptions = {
      viewport: {
        width: 100,
        height: 100,
        type: 'circle'
      },
      boundary: {width: 150, height: 150},
    };

     let options = _.get(scope, 'options', defaultOptions);

    /*
    From https://foliotek.github.io/Croppie/#documentation
    result({type, size, format, quality, circle }): Get the resulting crop of the image.
      type The type of result to return defaults to 'canvas'
        'base64' returns a the cropped image encoded in base64
        'html' returns html of the image positioned within an div of hidden overflow
        'blob' returns a blob of the cropped image
        'rawcanvas' returns the canvas element allowing you to manipulate prior to getting the resulted image
      size The size of the cropped image defaults to 'viewport'
        'viewport' the size of the resulting image will be the same width and height as the viewport
        'original' the size of the resulting image will be at the original scale of the image
        {width, height} an object defining the width and height. If only one dimension is specified, the other will be calculated using the viewport aspect ratio.
      format Indicating the image format.
        Default:'png'
        Valid values:'jpeg'|'png'|'webp'
      quality Number between 0 and 1 indicating image quality.
        Default:1
      circle force the result to be cropped into a circle
        Valid Values:true false
     */
    options.update = function() {
      let isCircle = _.get(options, 'type') === true;
      let width = _.get(options, 'viewport.width', 100);
      let height = _.get(options, 'viewport.height', 100);

      croppie.result({
        type: 'blob',
        size: {width: width, height: height},
        format: 'jpeg',
        quality: 0.9,
        circle: isCircle
      }).then(function(image) {
        scope.$apply(function() {
          scope.ngModel = image;
        });
      });
    };

    let croppie = new $window.Croppie(element[0], options);

    scope.$onChanges = function(changesObj) {
      let src = _.get(changesObj, 'src.currentValue');
      if (!src) {
        return;
      }
      bind(src);
    };

    function bind(source) {
      croppie.bind({
        url: source
      });
    }

  }
}
